const randFormatter = new Intl.NumberFormat("en-ZA", {
  style: "currency",
  currency: "ZAR",
  minimumFractionDigits: 2,
});

const rateFormatter = new Intl.NumberFormat("en-ZA", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export function formatRand(cents: number): string {
  return randFormatter.format(cents / 100);
}

export function formatRate(rateCents: number): string {
  return `${rateFormatter.format(rateCents)} c/kWh`;
}

export function displayPeriod(periodId: string): string {
  return periodId.replace("-", "/");
}
